import { PackageItem } from "@today/api/taker/types/PackageItem"

export function getPackageItemStateName(orderState: PackageItem["state"]) {
  switch (orderState) {
    case "PENDING_PACKING":
      return "포장 대기"
    case "IN_PACKING":
      return "포장 완료"
    case "IN_SHIPPING":
      return "배송 중"
    case "DELIVERED":
      return "배송 완료"
    case "QUIT":
      return "배송 중단"
    default:
      return orderState
  }
}
